
import React, { useContext } from 'react';
import { Button } from 'react-bootstrap';
import { StyleContext } from '../context';
import { WHITE } from '../helpers/constants/colors';
import { toCurrency } from '../helpers/functions/math';

const TableFooter = ({clearAll}) =>{
    const {items, sum} = useContext(StyleContext)
    return (
        <thead>
            <tr>
                <td><h5>Total</h5></td>
                <td><h5>{toCurrency(sum)}</h5></td>
                <td><Button variant={WHITE} onClick={clearAll} disabled={items.length <= 0}> Clear Table</Button></td>
            </tr>
        </thead>
    )
}


export default TableFooter;
